"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
var _default = exports.default = {
  name: 'HikeAttendantReport',
  data() {
    return {
      hikeId: '',
      hikeTitle: '',
      loading: false,
      downloadLoading: false,
      report: null,
      column: null
    };
  },
  async created() {
    const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    this.hikeTitle = this.$route.query.title ? this.$route.query.title : '-';
    this.hikeId = id;
    this.getReport(id);
  },
  methods: {
    checkPermission: _permission.default,
    getReport(id) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getAttendantReport)(token, id).then(response => {
        var resp = response.data;
        console.log('before convert', this.report);
        this.convertToTableFormat(resp.report);
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-attendantReport-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/index`);
    },
    convertToTableFormat(data) {
      console.log('data', data);
      var tempColumn = [];
      var tempReportData = [];
      for (var i = 0; i < data.length; i++) {
        tempColumn.push(data[i].title);
        console.log('attendantRecordd', data[i].attendantRecords);
        for (var j = 0; j < data[i].attendantRecords.length; j++) {
          if (i == 0) {
            var record = {};
            console.log('user attendantRecordd', data[i].attendantRecords[j]);
            record['email'] = data[i].attendantRecords[j]['email'];
            record['firstName'] = data[i].attendantRecords[j]['givenName'];
            record['lastName'] = data[i].attendantRecords[j]['familyName'];
            record[`stage${i + 1}`] = data[i].attendantRecords[j]['isCheckedIn'];
            console.log("add row");
            tempReportData.push(record);
          } else {
            console.log("amend row");
            tempReportData[j][`stage${i + 1}`] = data[i].attendantRecords[j].isCheckedIn;
          }
        }
      }
      this.column = tempColumn;
      this.report = tempReportData;
      console.log('after convert', this.report);
      console.log('after convert-column', this.column);
    },
    handleDownload() {
      this.downloadLoading = true;
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        var header = [];
        header.push('Given name');
        header.push('Surname');
        header.push('Email');
        for (var i = 0; i < this.column.length; i++) {
          console.log('build header add');
          header.push(`Stage ${i + 1} - ${this.column[i]}`);
        }
        const tHeader = header;
        // const data = this.formatJson(filterVal, list)
        const xdata = this.buildExcelData();
        excel.export_json_to_excel({
          header: tHeader,
          data: xdata,
          filename: 'Hike Attendance Report',
          autoWidth: true,
          bookType: 'xlsx'
        });
        var header = [];
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    buildExcelData() {
      var excelData = [];
      console.log('report row number', this.report.length);
      for (var i = 0; i < this.report.length; i++) {
        var row = [];
        row.push(this.report[i].firstName);
        row.push(this.report[i].lastName);
        row.push(this.report[i].email);
        for (var j = 0; j < this.column.length; j++) {
          row.push(this.report[i][`stage${j + 1}`]);
        }
        console.log("add excel row", row);
        excelData.push(row);
      }
      return excelData;
    }
  }
};